import React from "react";
import {getDetailsText} from "../components/SceneExplorer";
import "./Model3dInfos.scss";

export function Model3dInfos({node, property, isTopNode, setSelected}) {
    const detailsText = getDetailsText(node.object3d);
    return (
        <div className="Model3dInfos">
            {detailsText}
        </div>
    );
}
